import {
  CancelPlanResultDialog,
  DowngradeConfirmationDialog,
  DowngradeVideoDialog,
  SubscriptionFeedbackDialog,
  SubscriptionScheduledDialog,
} from '@aibees/shared/features/subscription-manager/components';
import { cloneElement, memo } from 'react';
import { useSubscriptionFlow } from './hooks/use-subscription-flow';
import type { SubscriptionManagerProps as Props } from './types';
import { Box } from '@mui/material';
import * as SX from './sx';

export const SubscriptionManager = memo(
  ({ className, actionMode, triggerElement }: Props) => {
    const {
      activeModal,
      closeModal,
      onStart,
      videoDialogProps,
      confirmDialogProps,
      feedbackDialogProps,
      resultDialogProps,
    } = useSubscriptionFlow(actionMode);

    const actionElement = cloneElement(triggerElement, { onClick: onStart });

    return (
      <Box sx={SX.root}>
        {actionElement}
        <DowngradeVideoDialog
          activeModal={activeModal}
          closeModal={closeModal}
          {...videoDialogProps}
        />
        <DowngradeConfirmationDialog
          activeModal={activeModal}
          closeModal={closeModal}
          {...confirmDialogProps}
        />
        <SubscriptionFeedbackDialog
          activeModal={activeModal}
          closeModal={closeModal}
          {...feedbackDialogProps}
        />
        <SubscriptionScheduledDialog
          activeModal={activeModal}
          closeModal={closeModal}
          {...resultDialogProps}
        />
        <CancelPlanResultDialog
          activeModal={activeModal}
          closeModal={closeModal}
          {...resultDialogProps}
        />
      </Box>
    );
  }
);

SubscriptionManager.displayName = 'SubscriptionManager';
